import { Banner, Button, Col, Row, Typography } from 'darrius';

import { HowWorksData } from '../../../data/home/homeData';

import styles from './HowWorks.module.scss';

export const HowWorks = ({ buttonText = HowWorksData.buttonText, buttonLink = HowWorksData.buttonLink }) => {
  return (
    <Banner as="section" className={`${styles['how-works']} full`}>
      <Row>
        <Col className="col-sm-12">
          <Row className={`middle-sm space-top`}>
            <Col className={`col-sm-12 col-md-2 ${styles['icon']} hide-mobile`}>
              <img
                src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/info.png`}
                alt="Icone de exclamação"
              />
            </Col>
            <Col className="col-sm-12 col-md-5">
              <Typography.Title size="3xl">
                {HowWorksData.title}
              </Typography.Title>

              <Typography.Text className={`${styles['itens']}`}>
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/1hw.png`}
                  alt="Numero 1"
                  width={20}
                />
                O cliente faz um pedido de serviço na plataforma
              </Typography.Text>

              <Typography.Text className={`${styles['itens']}`}>
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/2hw.png`}
                  alt="Numero 2"
                  width={20}
                />
                Profissionais próximos recebem a solicitação em tempo real
              </Typography.Text>

              <Typography.Text className={`${styles['itens']}`}>
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/3hw.png`}
                  alt="Numero 3"
                  width={20}
                />
                O profissional compra moedas para liberar o contato do cliente e
                fechar o serviço.
              </Typography.Text>

              <Typography.Text className={`${styles['description']}`}>
                <strong>
                  Ficou com alguma dúvida? Saiba mais no vídeo ao lado.
                </strong>
              </Typography.Text>

              <Button.Link
                href={buttonLink}
                className="button primary default left register-for-free__button"
                type="submit"
              >
                <span>{buttonText}</span>
              </Button.Link>
            </Col>
            <Col className="col-sm-12 col-md-5 center-sm">
              <iframe
                width="420"
                height="315"
                src={HowWorksData.videoLink}
                title="Video como funciona"
              ></iframe>
            </Col>
          </Row>
        </Col>
      </Row>
    </Banner>
  );
};
